import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

const contentBlockInclusionsValidationObject = objectOf({
  id: string,
  includer_class: string,
  includer_name: string,
  includer_type: string,
  includer_url: string,
  includer_created_at: number,
});

export const isEngagementContentBlockInclusionsResult = objectOf({
  hits: number,
  results: arrayOf(contentBlockInclusionsValidationObject),
  content_block_name: string,
});
